const BaseView = require('components-framework/view/base.view');
function toggleDrawer(model, enabled) {
    this.$el.find('.drawer_wrapper').toggleClass('od-drawer-generic-visible', enabled);
    this.addOpeningTransition(enabled);
    if (!enabled) {
        this.options.onCloseDrawer();
    }
    Odigeo.trigger('drawer-generic:toggleViewPortLock', enabled);
}

module.exports = BaseView.extend({
    events: {
        'click .close_drawer': 'closeDrawer',
    },

    initialize(options) {
        this.options = Odigeo._.extend({
            keys: {},
        }, options);
        this.options.template = this.templates.main;
        this.render(this.options);
        this.bindModelEvents();
        options.contentFactory.create(Odigeo._.extend({
            el: this.$el.find('.drawer_content'),
        }, options.extraOptions));
    },

    render(options) {
        const {template} = options;
        this.$el.html(template(options));
    },

    bindModelEvents() {
        this.listenTo(this.model, 'change:enabled', toggleDrawer);
    },

    closeDrawer() {
        this.model.set('enabled', false);
    },

    addOpeningTransition(value) {
        setTimeout(Odigeo._.bind(function() {
            this.$el.find('.drawer_wrapper').toggleClass('open opened', value);
        }, this), 10);
    },
});
